import { render, staticRenderFns } from "./injuryModal.vue?vue&type=template&id=0ebf1518&scoped=true&"
import script from "./injuryModal.vue?vue&type=script&lang=js&"
export * from "./injuryModal.vue?vue&type=script&lang=js&"
import style0 from "./injuryModal.vue?vue&type=style&index=0&id=0ebf1518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf1518",
  null
  
)

export default component.exports